import { gsap }             from "gsap";
import { ScrollTrigger }    from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


let needHelp = {
    init() {
        if($('body').hasClass('page-node-type-homepage') ||
            $('body').hasClass('page-node-type-landing') ||
            $('body').hasClass('user-logged-in')){


            setTimeout(function(){
                needHelp.blocNeedHelp();
            }, 300);
        }
    },
    blocNeedHelp() {
        let tlBNH = gsap.timeline({
            scrollTrigger: {
                trigger: '.block-need-help',
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1,
                toggleActions : 'play none none reverse',
                markers: false,
                refreshPriority: -1,
            }
        })
        tlBNH.to(".block-need-help ul:nth-child(2)", {duration: 1, y: -370}, 0);
        tlBNH.to(".block-need-help ul:nth-child(1)", {duration: 1, y: 200}, 0);
        tlBNH.to(".block-need-help ul:nth-child(3)", {duration: 1, y: 200}, 0);
    }
}

export default needHelp;
